import { ProductService } from 'src/app/components/shared/services/product.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.sass']
})
export class CategoriesComponent implements OnInit {

  constructor(
    private productService: ProductService
  ) { }
  listCatalogo: any[]=[];
  ngOnInit() {
    this.productService.getPedidos
  }

}
